import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import {useTranslation} from 'react-i18next';


const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        fontSize: 20,
        display: 'flex',
        alignItems: 'flex-start',
       
        flexDirection: 'row',
        marginTop: '0px',
        marginLeft: '40px',
        marginRight: '40px',
        marginBootom: '10px',
        
      
        flexGrow: 1,
    },
    itemName: {
        width: '35%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    catalog: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
       
        marginLeft: '15px'
    },
    um: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceOnePcs: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    vat: {
        width: '5%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceExcludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    priceIncludeVat: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
  });


const InvoiceTableRow = ({items}) => {

    const [t] = useTranslation();     

    const rows = items ? items.map(( item , i) => {
//item.id.toString()
            return(
                <View style={styles.row} key={i}>
                    <Text style={styles.itemName}>{item.itemName}</Text>
                    <Text style={styles.catalog}>{item.catalog}</Text>
                    <Text style={styles.qty}>{item.qty}</Text>
                    <Text style={styles.um}>{t('document.label.'+item.um)}</Text>
                    <Text style={styles.priceOnePcs}>{(item.unitPriceExcludeVat ? item.unitPriceExcludeVat : 0).toFixed(2)}</Text>
                    <Text style={styles.vat}>{item.vat}</Text>
                    <Text style={styles.priceExcludeVat}>{(item.totalPriceExcludeVat ? item.totalPriceExcludeVat : 0).toFixed(2)}</Text>
                    <Text style={styles.priceIncludeVat}>{(item.totalPriceIncludeVat ? item.totalPriceIncludeVat : 0).toFixed(2)}</Text>
                </View>
            )
        }
    ) : null
    return (<Fragment>{rows}</Fragment> )
};
  
  export default InvoiceTableRow
